import { IconBuildingStore, IconKey, IconLogout, IconMail, IconUser } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AvatarMenu, AvatarMenuItem } from '@mygpt/app';

import { useLogin } from '@/hooks/useLogin';
import { useGPTStore } from '@/store';
import { useAdminStore } from '@/store/admin';

const hasConfig = (userInfo: any, key: string): boolean => {
  if (!userInfo?.userconfigs) return false;
  return userInfo.userconfigs.some((c: any) => c.key === key && String(c.value).toLowerCase() === 'true');
};

export default () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { userInfo } = useGPTStore((state) => state);
  const { logout } = useLogin();
  const { unreadMessageCount } = useAdminStore((state) => state);

  const isCloudMode = import.meta.env.VITE_MODE !== 'local';
  const hasUnread = isCloudMode && unreadMessageCount > 0;

  const isSuperAdmin = hasConfig(userInfo, 'super_admin');
  const isDealerAdmin = hasConfig(userInfo, 'dealer_admin');
  const dealerPath = isSuperAdmin ? '/dealers' : '/dealers/me';

  const menuItems: AvatarMenuItem[] = [
    {
      key: 'account',
      label: t('account.title'),
      onClick: () => navigate('/account'),
      icon: <IconUser size={15} />,
    },
    // v0.5: 代理店管理入口（与「个人中心」同级，仅 SUPER_ADMIN / DEALER_ADMIN 可见）
    // SUPER_ADMIN → 「代理店管理」（管理所有代理店）
    // DEALER_ADMIN → 「折扣券管理」（实际就是自家 Coupon/PromotionCode 管理）
    ...(isSuperAdmin || isDealerAdmin
      ? [
          {
            key: 'dealer-management',
            label: isSuperAdmin ? t('dealer.menu', 'ディーラー管理') : t('dealer.menu_dealer_admin', 'クーポン管理'),
            onClick: () => navigate(dealerPath),
            icon: <IconBuildingStore size={15} />,
          },
        ]
      : []),
    ...(isCloudMode
      ? [
          {
            key: 'message-center',
            label: t('menu.message_center', '消息中心'),
            onClick: () => navigate('/message-center'),
            icon: <IconMail size={15} />,
            showBadge: hasUnread,
          },
        ]
      : []),
    {
      key: 'api-keys',
      label: t('menu.api_keys'),
      onClick: () => navigate('/keys'),
      icon: <IconKey size={15} />,
    },
    {
      key: 'logout',
      label: t('logout'),
      onClick: () => logout(),
      color: 'danger' as const,
      icon: <IconLogout size={15} />,
    },
  ];

  if (!userInfo) return null;

  return <AvatarMenu userInfo={userInfo} menuItems={menuItems} showBadge={hasUnread} />;
};
